/**
 * 숫자만 받는 칸의 걸러개. 빈 문자열과 `^\d+$` 만 통과하고 나머지는 `null` 이라 상태에 들어가지 않는다 —
 * 음수·소수·글자는 화면에 나타나지도 않으므로 막힘 문장을 둘 일이 없다.
 *
 * `type="number"` 를 쓰지 않는 이유가 이것이다: `-` 나 `1e3` 처럼 반쯤 친 상태에서 값이 빈 문자열로 와
 * **비운 칸과 잘못 친 칸이 구별되지 않는다.** 비운 칸이 뜻을 갖는 화면(자유)에서는 쓸 수 없다.
 */
export function digits(raw: string): string | null {
  if (raw === '') return ''
  return /^\d+$/.test(raw) ? raw : null
}
